



























import Vue from 'vue'
import Component from 'vue-class-component'

@Component < GlobalError > ({})
export default class GlobalError extends Vue {
  get globalError(): string {
    return this.$store.getters.globalError
  }

  public reload() {
    (window as any).document.location.reload()
  }

  public resetError() {
    this.$store.dispatch('setGlobalError')
  }
}
